import type { Features } from '@onhandtech/onhand-fe-shared/lib/contracts/config/features'
import type { FeatureNames } from 'contracts/config/features'

export const moduleName = 'features'

export type FeaturesState = {
  features: Features<FeatureNames>
}
